import type { EditorCardProps } from '../store'

export const buildFlashcardProps = (card: EditorCardProps) => ({
  width: card.width,
  height: card.height,
  darkMode: card.darkMode,
  backgroundColor: card.backgroundColor,
  borderColor: card.borderColor,
  borderWidth: card.borderEnabled ? card.borderWidth : 0,
  borderRadius: card.borderRadius,
  shadow: card.shadowEnabled
    ? `${card.shadowX}px ${card.shadowY}px ${card.shadowBlur}px ${card.shadowSpread}px ${
        card.shadowColor || 'rgba(15, 23, 42, 0.18)'
      }`
    : 'none',
  transitionDuration: card.transitionDuration,
  flipAnimation: card.flipAnimation,
  hoverFlip: card.hoverFlip,
  showBackFirst: card.showBackFirst,
  checkboxTickStyle: card.checkboxTickStyle,
  themeBackgroundColor: card.themeBackgroundColor,
  themeBorderColor: card.themeBorderColor,
  themeBorderRadius: card.themeBorderRadius,
  themeTransitionDuration: card.themeTransitionDuration,
  themeFlipAnimation: card.themeFlipAnimation,
})
